import { useState, useEffect } from 'react'
import _ from 'lodash'

const useFonts = (fonts) => {
  // State
  const [fontFaces, setFontFaces] = useState()
  const [fontsLoaded, setFontsLoaded] = useState(false)

  const loadFontFace = async (fontFace) => {
    const loadedFont = await fontFace.load()
    document.fonts.add(loadedFont)
  }

  useEffect(() => {
    if (fontFaces && fontFaces.length > 0) {
      setFontsLoaded(false)
      Promise.all(fontFaces.map((fontFace) => loadFontFace(fontFace)))
        .then(() => {
          // Wait for document.fonts to be ready
          return document.fonts.ready
        })
        .then(() => {
          setFontsLoaded(true)
        })
        .catch((error) => {
          console.error('Error loading fonts:', error)
          // Set to true anyway to prevent blocking the UI
          setFontsLoaded(true)
        })
    } else if (!fontFaces || fontFaces.length === 0) {
      // No custom fonts to load
      setFontsLoaded(true)
    }
  }, [fontFaces])

  const convertFontFiletoBase64 = async (file) => {
    const base64 = await new Promise((resolve) => {
      const fileReader = new FileReader()
      fileReader.onload = () => resolve(fileReader.result)
      fileReader.readAsDataURL(file)
    })
    return base64
  }

  useEffect(() => {
    if (fonts && fonts.length > 0) {
      // Immediately mark as not loaded — without this, fontsLoaded stays true
      // from a previous empty-array state during the async fetch below, creating
      // a false positive gap until the fontFaces effect sets it to false.
      setFontsLoaded(false)

      // Filter out any null fonts
      const updatedFonts = _.filter(fonts, (f) => f !== null)

      // Load the signed URLs for the fonts
      Promise.all(
        updatedFonts.map(async (font) => {
          const file = await fetch(font.signedUrl)
          const blob = await file.blob()

          // Convert the font files to base64
          const base64 = await convertFontFiletoBase64(blob)
          return { ...font, base64 }
        }),
      ).then((processedFonts) => {
        // FIXME: Support variants for fonts
        setFontFaces(processedFonts.map((font) => new FontFace(font.name, `url(${font.base64})`)))
      })
    } else {
      // No fonts provided, mark as loaded
      setFontsLoaded(true)
    }
  }, [fonts])

  return fontsLoaded
}

export default useFonts
